<template>
  <div class="product-wrap">
    <div class="date-picker">
      <el-date-picker
        v-model="monthValue"
        type="month"
        class="date-table"
        placeholder="请选择月份"
        @change="dateChange"
        :picker-options="DatapickerOptions"
      ></el-date-picker>
      <el-button @click="BtnClicked" class="search_btn" type="info">
        查找</el-button
      >
      <el-button
        class="download-content"
        type="primary"
        @click="JudgExport"
        v-if="developerInfo.studio_position === 1"
      >
        导出工作室数据</el-button
      >
    </div>
    <div class="data-table">
      <el-table :data="productData" stripe>
        <el-table-column label="地图名称" prop="name" align="center" fixed>
        </el-table-column>
        <el-table-column label="上传日期" prop="create_time" align="center">
        </el-table-column>
        <el-table-column align="center">
          <template slot="header"><span>内容质量审核状态</span> </template>
          <template slot-scope="scope">
            <span
              class="active state"
              @click="openDialog(scope.row)"
              v-if="scope.row.state == '内容质量不合格'"
            >
              <!-- 内容质量不合格 -->
              {{ scope.row.state }}
            </span>
            <span v-else> {{ scope.row.state }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="当月奖金"
          prop="money"
          v-if="!nowMonthBle"
        >
        </el-table-column>
        <el-table-column align="center">
          <template slot="header"><span>操作</span> </template>
          <template slot-scope="scope">
            <span class="all-look" @click="mapDetailClick(scope.row.id)">
              查看详情
            </span>
          </template>
        </el-table-column>
        <!-- 无数据的时候 -->
        <template slot="empty" v-if="nowMonthBle">
          <div class="img-no" v-if="showDefaultImg || !productData.length">
            <img
              class="img-no-data"
              src="../../../assets/images/img_table_no_data.png"
            />
            <div class="noCart">暂无数据</div>
          </div>
        </template>
        <template slot="empty" v-else>
          <div class="img-no" v-if="showDefaultImg || !productData.length">
            <img
              class="img-no-data"
              src="../../../assets/images/img_table_no_data.png"
            />
            <div class="noCart">暂未找到任何结果</div>
          </div>
        </template>
      </el-table>
    </div>
    <el-pagination
      background
      @current-change="CurrentChange"
      :current-page="pagePagination.page"
      :page-size="pagePagination.pageSize"
      layout="prev, pager, next,jumper"
      :total="pagePagination.total"
      hide-on-single-page
    >
    </el-pagination>
    <div class="dialog-wrapper">
      <!-- :show-close="false" -->
      <el-dialog
        :visible.sync="dialogBle"
        width="668px"
        class="dialog"
        title="星启计划-地图质量评定结果通知"
      >
        <div class="dialog-wrap">
          <div class="content">
            <div class="content-hr">
              你创作的地图：{{ cause.name }}，（地图ID：{{
                cause.id
              }}）质量评定结果为：待修改。
            </div>
            <div class="content-hr">
              未通过理由：{{ cause.desc }}，请及时修改。
            </div>
            <div class="content-hr">
              很遗憾你的地图没有通过星启计划3.0的质量评定，请参考我们提供的修改意见，并对地图的内容进行相关修改。如对相关结果存在疑问，请在7天内提交申诉，我们会在春节后统一进行仲裁评定。（更新地图后会重新进行质量评审并收到新的评定结果。若在提交仲裁后更新地图，则此地图不会被仲裁）
            </div>
          </div>
          <a
            href="https://wenjuan.feishu.cn/m?t=sEXxuTwnAhzi-gpea"
            target="_blank"
          >
            进行结果申诉</a
          >
          <!-- <div class="submit-wrap">
            <div class="submit2">
              <a
                href="https://wenjuan.feishu.cn/m?t=sEXxuTwnAhzi-gpea"
                target="_blank"
                >申诉入口</a
              >
            </div>
          </div> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { fetchStarProduct, exportStudioData } from '@/api/activity';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      productData: [],
      dialogBle: false,
      showDefaultImg: false,
      nowMonthBle: true, //表示是否是当前月份
      cause: {},
      monthValue: '',
      pagePagination: {
        page: 1,
        pageSize: 30,
        total: 0,
      },
      nowDateTime: 0,
      // date1: '2022-06-01 00:00:00',
      DatapickerOptions: {
        //不能选择的时间
        disabledDate(time) {
          let date1;
          const ua = navigator.userAgent;
          //ios不能使用yy-mm格式，需要使用yy/mm格式
          // ios
          if (/iPhone|iPad/gi.test(ua)) {
            date1 = new Date('2022/05/01 00:00:00').getTime();
          } else {
            date1 = new Date('2022-05-01 00:00:00').getTime();
          }
          return time.getTime() > Date.now() || time.getTime() < date1;
        },
      },
    };
  },
  watch: {
    productData(val) {
      this.showDefaultImg = !(val && val.length);
    },
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  methods: {
    init() {
      this.getMonthTime();
      this.monthValue = new Date();
      // let year = new Date().getFullYear();
      // let month =
      //   new Date().getMonth() + 1 < 10
      //     ? '0' + (new Date().getMonth() + 1)
      //     : new Date().getMonth() + 1;
      // //this.monthValue = year + '' + month;
      this.getProductDetail();
    },
    // getTargetTime(t) {
    //   let d = t.split(' ')[0],
    //     h = t.split(' ')[1],
    //     date = new Date();
    //   date.setYear(d.split('-')[0]);
    //   date.setMonth(d.split('-')[1] - 1);
    //   date.setDate(d.split('-')[2]);
    //   date.setHours(h.split(':')[0]);
    //   date.setMinutes(h.split(':')[1]);
    //   date.setSeconds(h.split(':')[2]);
    //   return date.getTime();
    // },
    dateChange() {},
    //获取当前年-月的时间戳
    getMonthTime() {
      let nowYear = new Date().getFullYear();
      let nowMonth = new Date().getMonth(); //比当前月份少一个月
      this.nowDateTime = new Date(nowYear, nowMonth, 1).getTime();
    },
    JudgExport() {
      this.fetchExport();
    },
    async fetchExport() {
      let year = this.monthValue.getFullYear();
      let month =
        this.monthValue.getMonth() + 1 < 10
          ? '0' + (this.monthValue.getMonth() + 1)
          : this.monthValue.getMonth() + 1;
      let month_value = year + '' + month;
      let data = {
        month: month_value,
      };
      try {
        const res = await exportStudioData(data);
        if (res.code === 218) this.$message.error(res.msg);
        else {
          this.downloadFile(res.data.url);
          this.$message.success('下载成功');
        }
      } catch (error) {
        console.log(error);
      }
    },
    //下载数据
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    openDialog(content) {
      this.cause = content;
      this.dialogBle = true;
    },
    BtnClicked() {
      let dateYear = new Date(this.monthValue).getFullYear();
      let dateMonth = new Date(this.monthValue).getMonth();
      let dateTime = new Date(dateYear, dateMonth, 1).getTime();
      if (dateTime == this.nowDateTime) this.nowMonthBle = true;
      else this.nowMonthBle = false;
      this.getProductDetail();
    },
    mapDetailClick(tid) {
      this.$router.push({ path: '/charts/detail', query: { id: tid } });
    },
    CurrentChange(currPage) {
      this.pagePagination.page = currPage;
      this.getProductDetail();
    },
    async getProductDetail() {
      let year = this.monthValue.getFullYear();
      let month =
        this.monthValue.getMonth() + 1 < 10
          ? '0' + (this.monthValue.getMonth() + 1)
          : this.monthValue.getMonth() + 1;
      let month_value = year + '' + month;
      let data = {
        page: this.pagePagination.page,
        page_size: this.pagePagination.pageSize,
        month: month_value,
      };
      const res = await fetchStarProduct(data);
      if (res.code !== 218) {
        if (res.data.list.length) {
          this.productData = res.data.list.map(item => {
            // if (item.desc) {
            item.state = item.desc;
            // } else {
            //   if (item.state == 1 || item.state == 'G' || item.state == 'P') {
            //     item.state = '内容质量合格';
            //   } else if (item.state == 'F1' || item.state == 'F2') {
            //     item.state = '内容质量不合格';
            //   } else if (item.state == 'F3') {
            //     item.state = '内容质量不合格';
            //     item.desc = '你的地图在游戏玩法设计以及内容量设置上稍显不足';
            //   } else {
            //     item.state = '待审核';
            //   }
            // }
            if (item.money === -1) item.money = '请与室长确认收益';
            item.create_time = this.regroupFilDate(item.create_time);
            return item;
          });
        } else this.productData = [];
        this.pagePagination.total = res.data.total_count;
      }
    },
    regroupFilDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
$--color-primary: #fd9b21;
.data-table {
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  overflow: hidden;
  border-radius: 3px;
  ::v-deep .el-table tr:last-child td {
    border-bottom: none;
  }
  ::v-deep .el-table::before {
    background: transparent;
  }
  ::v-deep .el-table th {
    background: #fafafa;
    line-height: 29px;
  }
  ::v-deep .el-table td {
    line-height: 29px;
    padding: 7px 0 6px;
  }
  ::v-deep.el-table .cell {
    padding: 0 5px;
  }
  .img-no {
    margin: 20px auto 10px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img-no-data-word {
      margin: 10px auto;
    }
  }
  ::v-deep .el-table__empty-text {
    line-height: 30px;
    margin-bottom: 15px;
    margin-top: 15px;
  }

  .all-look {
    color: #2b6ddf;
    display: flex;
    cursor: pointer;
    justify-content: center;
  }
  .active.state {
    color: #2b6ddf;
    cursor: pointer;
  }
  img.icon-help {
    height: 10px;
    width: 10px;
  }
}
.date-picker {
  margin-top: 10px;
  margin-bottom: 30px;
  .search_btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
    color: #595959;
    border-right: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    background-color: #f4f4f5;
  }
}
.el-button--primary {
  //back
  background-color: #409eff;
  border-color: #409eff;
  font-size: 16px;
  float: right;
}
.el-pagination {
  text-align: center;
  margin-top: 19px;
}
::v-deep .el-dialog__header {
  text-align: center;
  font-size: 24px;
  color: #262626;
  padding-top: 40px;
}
::v-deep .el-dialog__body {
  padding-top: 20px;
  .dialog-wrap {
    .content {
      font-size: 16px;
      // text-align: center;
      margin-bottom: 10px;
      color: #262626;
      .content-hr {
        margin-top: 10px;
      }
    }
    a {
      font-size: 16px;
      color: #2b6ddf;
    }
  }
}
::v-deep {
  .el-pagination.is-background .el-pager li,
  .el-pagination.is-background button {
    width: 32px;
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled) {
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    color: $--color-primary;
    border: 1px solid #ffc973;
    background: #fffaed;
    border-radius: 4px;
  }
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next {
    background-color: #fff;

    border-radius: 4px;
    border: 1px solid #d9d9d9;
  }
}
</style>
